// Simplified type definitions for demo mode
// These are simplified versions of the TypeScript models from the main app

export const QuestionType = {
  SingleChoice: 0,
  MultipleChoice: 1,
  FreeText: 2
};

// Helper to get question type display name
export const getQuestionTypeName = (type) => {
  switch (type) {
    case QuestionType.SingleChoice:
      return 'Single Choice';
    case QuestionType.MultipleChoice:
      return 'Multiple Choice';
    case QuestionType.FreeText:
      return 'Free Text';
    default:
      return 'Unknown';
  }
};
